import React, { useEffect, useState } from 'react';
import {
  Box,
  Drawer,
  DrawerContent,
  useColorModeValue,
  useDisclosure,
  useMediaQuery,
} from '@chakra-ui/react';
import Header from '../header';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { routes } from '../../routes';
import Sidebar from '../sidebar';

function BasePage() {
  const user = useSelector(state => state.userState.user);
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const [nestedRoutes, setNestedRoutes] = useState([]);
  const bg = useColorModeValue('gray.100', 'gray.900');

  useEffect(() => {
    if (!user) {
      navigate('/');
    } else if (nestedRoutes.length === 0) {
      setNestedRoutes(getRoutes(routes));
    }
  }, [user, navigate, nestedRoutes.length]);

  const getRoutes = (items) => {
    let allRoutes = [];
    items.forEach(item => {
      if (item.items && item.items.length > 0) {
        allRoutes = allRoutes.concat(getRoutes(item.items));
      } else {
        allRoutes.push(item);
      }
    });
    return allRoutes;
  }

  if (!user) {
    return null;
  }

  return (
    <>
      <Box minH='100vh' bg={bg}>
        {!isMobile ? <Sidebar onClose={onClose} /> : <></>}
        <Drawer
          isOpen={isOpen}
          placement='left'
          onClose={onClose}
          onOverlayClick={onClose}
          size='full'>
          <DrawerContent>
            <Sidebar onClose={onClose} />
          </DrawerContent>
        </Drawer>
        <Header onOpen={onOpen} />
        <Box ml={{ base: 0, md: 60 }} p='4' data-testid="base-page-content-holder">
          <Routes>
            {nestedRoutes.length > 0 &&
              nestedRoutes.map((route, idx) => {
                return <Route path={route.to} element={route.component} key={`${route.name}-${idx}`} />;
              })
            }
          </Routes>
        </Box>
      </Box>
    </>
  );
}

export default BasePage;
